import useFetch from "./useFetch";

export default useFetch;
